export const LOGINPAGE = 'loginPage';
export const LOGINSSOPAGE = 'loginSsoPage';
